/* eslint-disable benchlint/no-react-context */
import {createContext, useContext} from 'react';

import {ActionOrigin} from 'constants/AnalyticsConstants';

/**
 * @package
 */
export interface DataLayoutContextValue {
  actionOrigin: ActionOrigin;
  clientId: string;
}

const DataLayoutContext = createContext<DataLayoutContextValue>(undefined as never);

/**
 * Context for `DataLayout`.
 *
 * @package
 */
export default DataLayoutContext;

export function useDataLayoutContext(): DataLayoutContextValue {
  const context = useContext(DataLayoutContext);
  if (!context) {
    throw new Error('DataLayoutContext not found. If this is a test, use DataLayoutTestWrapper.');
  }

  return context;
}
